// extracted by mini-css-extract-plugin
module.exports = {"voteBtn":"Vote_voteBtn__1Oga9","icon":"Vote_icon__2NYFM","voteBtnDisable":"Vote_voteBtnDisable__1Wexs","voteIcon":"Vote_voteIcon__2J3K1","tooltip":"Vote_tooltip__3hBlY"};